import csatKeys from '@/constants/configuration/csat-keys.json';
import tfaStatuses from '@/constants/tfa-status';
import API_AUTH_LOGIN from '@/services/api/authLogin.js';
import API_CONFIG from '@/services/api/config.js';
import API_DEX from "@/services/api/dex.js";
import API_LOGIN from '@/services/api/login.js';
import API_LOGOUT from '@/services/api/logout';
import API_PROFILE from '@/services/api/profile.js';
import API_TFA from '@/services/api/twoFactorAuthenticatication.js';
import API_RENEW_TOKEN from '@/services/api/renewToken.js';
import { getEnvAndDex } from '@/utils/get-env-and-dex';
import axios from 'axios';
import moment from 'moment';

const { env } = getEnvAndDex();

function handleTfa(user) {
	const { tfaRequired, tfaUserSetup, tfaVerified } = user

	let tfaStatus = tfaStatuses.none

	if (user?.isAdmin) {
		return tfaStatus = tfaStatuses.none
	}

	if (tfaVerified) {
		return tfaStatus = tfaStatuses.none
	}

	if (tfaUserSetup) {
		return tfaStatus = tfaStatuses.otp
	}

	if (tfaRequired) {
		return tfaStatus = tfaStatuses.setUp
	}

	return tfaStatus = tfaStatuses.none
}

async function handleUser(response) {
	const { user } = response

	let [profile, type] = [[], "participant"]

	if ((!user?.tfaRequired) || (user?.tfaRequired && user?.tfaVerified)) {
		profile = (await API_PROFILE.index())[1]

		if (profile?.organization?.status !== "APPROVED") {
			type = "nonParticipant"
		}
	}

	if (user?.isAdmin) {
		type = "admin"
	}

	return {
		type,
		profile
	}
}

function syncProfile() {
	return async (dispatch) => {
		const profile = (await API_PROFILE.index())[1]

		dispatch({
			type: 'auth/syncProfile',
			payload: profile
		})

		sessionStorage.setItem('profile', JSON.stringify(profile))
	}
}

function login(goTo, credentials, flow) {
	return async (dispatch) => {
		let error, response

		switch (flow) {
			case "setUpTfa":
				[error, response] = await API_TFA.verifyTfa({ ...credentials })
				break;
			case "otpVerify":
				[error, response] = await API_TFA.validateTfa({ ...credentials })

				break;
			case "authLogin":
				[error, response] = await API_AUTH_LOGIN.create({ ...credentials })
				break;
			default:
				[error, response] = await API_LOGIN.create({ ...credentials, email: credentials.email.toLowerCase() })
				break;
		}

		const [dexError, dexResponse] = await API_DEX.index();

		const { features } = dexResponse;
		const featuresList = features || [];

		if(dexError) {
			throw new Error("Failed to load dex config");
		}

		if (error) {
			if (error.message === 'Invalid credentials.' || error.message === 'Failed to Fetch User Details' || error.message === 'Unable to retrieve user from DB') {
				throw new Error('credentialError')
			}

			if (String(error.message.toLowerCase()).includes("status code")) {
				throw new Error("An error occured! Please contact administrator.")
			}
			throw new Error(error.message)
		}

		const { token, user } = response;

		axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

		const responseConfig = (await API_CONFIG.index())[1]

		const { type, profile } = await handleUser(response)

		const tfaValue = handleTfa(user)



		dispatch({
			type: 'auth/login',
			payload: response,
			environments: responseConfig,
			userType: type,
			profile: profile,
			tfa: tfaValue,
			features: featuresList
		})

		sessionStorage.setItem('token', token)
		sessionStorage.setItem('user', JSON.stringify(user))
		sessionStorage.setItem('environments', JSON.stringify(responseConfig))
		sessionStorage.setItem('userType', type)
		sessionStorage.setItem('profile', JSON.stringify(profile))
		sessionStorage.setItem('lastTimeStamp', moment())
		sessionStorage.setItem('tfa', tfaValue)
		sessionStorage.setItem('features', JSON.stringify(featuresList));
		goTo(`/`)
	}
}

function logout(goTo) {
	return async (dispatch) => {
		await API_LOGOUT.create()

		dispatch({
			type: 'auth/logout'
		})

		sessionStorage.clear();
		delete axios.defaults.headers.common['Authorization'];

		// Removing only required keys from local storage due to CSAT Integration
		localStorage.removeItem('userEmail');
		localStorage.removeItem('lockedTime');
		localStorage.removeItem('lockedAccount');

		// Remove CSAT Integration
		const csatWidgetBaseUrl = csatKeys[env]?.CSAT_WIDGET_BASE_URL;
		const csatSpaceKey = csatKeys[env]?.CSAT_SPACE_KEY;
		if (document.querySelector(`script[src="${csatWidgetBaseUrl}${csatSpaceKey}?onload=onUserSnapLoad"]`)) {
			document.querySelector(`script[src="${csatWidgetBaseUrl}${csatSpaceKey}?onload=onUserSnapLoad"]`).remove();
		}
		goTo(`/login`)
		window.location.reload();
	}
}

function renewToken() {
	return async (dispatch) => {
		const currentToken = sessionStorage.getItem("token");
			const [error, response] = await API_RENEW_TOKEN.create(null, {
				headers: {
					Authorization: `Bearer ${currentToken}`,
				},
			});
			if (error) throw new Error(error.message);
			const { token, user } = response;
			axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
			sessionStorage.setItem("token", token);
			sessionStorage.setItem("user", JSON.stringify(user));
			sessionStorage.setItem("lastTimeStamp", moment());
			dispatch({
				type: "auth/renewToken",
				payload: { token, user },
			});
	};
}

export {
	login,
	logout,
	syncProfile,
	renewToken
};

